<script setup lang="ts">
import { useAssistantStore } from '../stores/assistant';
import '../styles/assistant.css';

/**
 * Bouton flottant « Demander à l'assistant », sur tous les écrans (maquette `#fab`). Lot AQ : placé par
 * `AppLayout` sous la bulle « Faire un retour », masqué quand un panneau est ouvert.
 */
const store = useAssistantStore();
</script>

<template>
  <button v-if="!store.open" class="fab" type="button" data-testid="assistant-fab" @click="store.show()">
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M8 0l1.6 4.8L14.4 6.4 9.6 8 8 12.8 6.4 8 1.6 6.4 6.4 4.8z" />
    </svg>
    Demander à l'assistant
  </button>
</template>
